import {
  Box, Grid, makeStyles, Typography, Hidden,
} from '@material-ui/core';
import PaymentIcon from '@material-ui/icons/Payment';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import StoryContext from '../../contexts/StoryContext';
import states from '../../modules/states';
import QuestionHeaderBox from '../QuestionHeaderBox';

function Q2Header() {
  const { stateCode } = useParams();
  const { primaryColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    root: {
      marginTop: theme.spacing(4),
    },
    question: {
      marginTop: theme.spacing(2),
      color: primaryColor,
    },
    headline: {
      fontWeight: 'bold',
    },
    whiteP: {
      color: '#fff',
    },
    definitionBox: {
      padding: theme.spacing(2),
      backgroundColor: `${primaryColor} !important`,
      color: '#fff !important',
    },
  }))();

  return (
    <Grid
      className={classes.root}
      container
      direction="row"
      justify="center"
      alignItems="center"
      spacing={4}
    >
      <Grid item xs={12}>
        <QuestionHeaderBox color={primaryColor}>
          {/* <HelpIcon style={{ color: primaryColor, fontSize: 60 }} align="center" /> */}
          <Typography variant="h3" component="h2" align="center" className={classes.question} gutterBottom>
            In {states[stateCode.toUpperCase()]}, can families in poverty afford child care?
          </Typography>
          <Hidden only="xs">
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ paddingBottom: 10 }}
            >
              <Grid item xs={3}>
                <Box className={classes.definitionBox} borderRadius={8}>
                  <Typography variant="h5" align="center">Affordability</Typography>
                  <Typography variant="body2" gutterBottom className={classes.whiteP}>the average price of child care vs. median household income.
                  </Typography>
                  <br />
                  <PaymentIcon style={{ fontSize: 40, color: '#fff' }} />
                </Box>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="body1" align="center" style={{ color: primaryColor, fontSize: 60 }}>=</Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body1" align="center">
                  Price of care as
                  a percentage of
                  median household income
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="body1" align="center" style={{ color: primaryColor, fontSize: 60 }}>=</Typography>
              </Grid>
              <Grid item xs={3}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="body1" align="center" style={{ marginTop: '20px' }}>Price of full time child care</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <hr style={{ border: `2px solid ${primaryColor}` }} />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" align="center">Median household income for families with children under 6</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>
          <Hidden smUp>
            <Typography variant="body1" align="center" style={{ color: primaryColor }}>
              The affordability of child care can be understood by looking at the price of care as a percentage of median household income.
            </Typography>
          </Hidden>
          <Typography variant="body1" align="center" style={{ marginTop: 10 }} gutterBottom>
            The Federal Poverty Level (FPL) is:<br />
            &ndash; $20,578 for a family of 3 with 2 adults and 1 child under 18<br />
            &ndash; $17,622 for a family of 2 with 1 adult and 1 child under 18
          </Typography>

        </QuestionHeaderBox>
      </Grid>
    </Grid>
  );
}

export default Q2Header;
